import { createRequest } from '@savgroup-front-common/core/services/request';

export const LOAD_BACK_OFFICE_LINK = createRequest(
  'REVERS.IO/ACCESS/LOAD_BACK_OFFICE_LINK',
);
